import { AbstractControl, ValidatorFn } from '@angular/forms';

export function fileSizeValidator(maxSizeInGB: number): ValidatorFn {
  const maxSizeInBytes = maxSizeInGB * 1024 * 1024 * 1024; // Convert GB to bytes
  return (control: AbstractControl): { [key: string]: any } | null => {
    const file = control.value;

    if (file && file.size > maxSizeInBytes) {
      return { 'fileSizeExceedsLimit': true };
    }

    return null;
  };
}
